import Swiper from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";

export default class Slider {
  constructor(slider) {
    this.type = slider.getAttribute("data-slider");
    this.createid();
    this.slider = slider;
    this.slider.id = `ID_${this.id}`;
    this.autoMobBreakpoint = window.matchMedia("(max-width: 991px)");

    if (this.type === "auto") this.tagAuto();
    if (this.type === "auto-mob") this.tagAutoMob();
    if (this.type === "project") this.projects();
    if (this.type === "vote") this.vote();
    if (this.type === "quote") this.quote();
    if (this.type === "sport") this.sportTag();
    if (this.type === "double") this.double();
  }

  double() {
    this.sliderDouble = new Swiper(`#ID_${this.id}`, {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesPerGroup: 1,
      allowTouchMove: false,
    });
  }

  tagAuto() {
    this.sliderAuto = new Swiper(`#ID_${this.id}`, {
      slidesPerView: "auto",
      spaceBetween: 0,
      slidesPerGroup: 2,
      modules: [Navigation],
      navigation: {
        nextEl: `#ID_${this.id} [data-slider-next]`,
        prevEl: `#ID_${this.id} [data-slider-prev]`,
      },
    });

    const tags = document.querySelectorAll("[data-news-filter]");
    const newsContainer = document.querySelectorAll("[data-news]");

    tags.forEach((tag) => {
      tag.addEventListener("click", (e) => {
        tags.forEach((button) => {
          button.classList.add("u-border--white");
        });
        e.target.classList.remove("u-border--white");
        const data = e.target.getAttribute("data-news-filter");

        newsContainer.forEach((news) => {
          news.classList.add("d-none");
          if (news.getAttribute("data-news") === data) {
            news.classList.remove("d-none");
          }
        });
      });
    });
  }

  tagAutoMob() {
    this.sliderAuto = new Swiper(`#ID_${this.id}`, {
      slidesPerView: "auto",
      spaceBetween: 10,
      slidesPerGroup: 3,
      modules: [Navigation],
      navigation: {
        nextEl: `#ID_${this.id} [data-slider-next]`,
        prevEl: `#ID_${this.id} [data-slider-prev]`,
      },
    });

    if (this.autoMobBreakpoint.matches) this.sliderAuto.disable();
    else this.sliderAuto.enable();

    this.autoMobBreakpoint.addEventListener("change", (e) => {
      if (e.matches) this.sliderAuto.disable();
      else this.sliderAuto.enable();
    });
  }

  projects() {
    this.sliderProject = new Swiper(`#ID_${this.id}`, {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesPerGroup: 1,
      modules: [Navigation, Scrollbar],
      navigation: {
        nextEl: `#ID_${this.id} [data-slider-next]`,
        prevEl: `#ID_${this.id} [data-slider-prev]`,
      },
      scrollbar: {
        el: "[data-slider-scrollbar]",
        hide: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
    });
  }

  vote() {
    const shuffle = (array) => {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    };

    const swiperWrapper = document.querySelector(
      "[data-slider='vote'] .swiper-wrapper",
    );
    const slides = Array.from(swiperWrapper.children);

    const shuffledSlides = shuffle(slides);
    swiperWrapper.innerHTML = "";
    shuffledSlides.forEach((slide) => swiperWrapper.appendChild(slide));

    this.sliderVote = new Swiper(`#ID_${this.id}`, {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesPerGroup: 1,
      loop: true,
      loopedSlides: 5,
      centeredSlides: true,
      // preloadImages: true,
      // lazy: true,
      // loopAdditionalSlides: 2,
      modules: [Navigation],
      navigation: {
        nextEl: `#ID_${this.id} [data-slider-next]`,
        prevEl: `#ID_${this.id} [data-slider-prev]`,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        1300: {
          centeredSlides: true,
          slidesPerView: 3,
        },
      },
    });

    const openButtons = document.querySelectorAll("[data-sport-button]");

    openButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const slideNum = button.getAttribute("data-sport-button");
        const popup = document.querySelector(
          `[data-sport-popup="${slideNum}"]`,
        );
        const close = popup.querySelector(`[data-sport-close]`);
        const innerClose = popup.querySelector(`[data-vote-close]`);
        popup.classList.add("open");

        close.addEventListener("click", () => {
          popup.classList.remove("open");
        });

        innerClose.addEventListener("click", () => {
          popup.classList.remove("open");
        });
      });
    });

    const setFormButtons = document.querySelectorAll("[data-set-name]");
    const select = document.querySelector("#vote form select");

    if (select && setFormButtons) {
      setFormButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const name = button.getAttribute("data-set-name");
          select.value = name;
        });
      });
    }
  }

  quote() {
    this.sliderQuote = new Swiper(`#ID_${this.id}`, {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesPerGroup: 1,
      modules: [Navigation],
      navigation: {
        nextEl: `#ID_${this.id} [data-slider-next]`,
        prevEl: `#ID_${this.id} [data-slider-prev]`,
      },
    });
  }

  sportTag() {
    this.sliderSport = new Swiper(`#ID_${this.id}`, {
      slidesPerView: "auto",
      spaceBetween: 10,
      slidesPerGroup: 3,
      modules: [Navigation],
      navigation: {
        nextEl: `#ID_${this.id} [data-slider-next]`,
        prevEl: `#ID_${this.id} [data-slider-prev]`,
      },
    });

    if (this.autoMobBreakpoint.matches) this.sliderSport.enable();
    else this.sliderSport.disable();

    this.autoMobBreakpoint.addEventListener("change", (e) => {
      if (e.matches) this.sliderSport.enable();
      else this.sliderSport.disable();
    });
  }

  createid() {
    this.id =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);
  }
}
